
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11.78 6.101v-5.984h1.652l.219-2.063H12.78l.003-1.032c0-.538.05-.826.823-.826h1.033V6.133h-1.652c-1.985 0-2.683 1-2.683 2.683v1.238H9.067v2.063h1.237V18.1h2.476z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    